import React, { useState } from "react";
import { Link } from "react-router-dom";
function Congrats() {
  const [key, setSecretKey] = useState({});
  return (
    <div>
      <div className="bg-img-main">
        <div className="bg-img"></div>
      </div>

      {/* ========================Home-Banner===================  */}
      <section id="banner">
        <div className="custom-container">
          <div className="sec-padding">
            <div className="row">
              <div className="col-lg-12">
                <div className="main">
                  <div className="box">
                    <div className="heading">
                      <h2>
                        Congratulation your wallet is created successfully
                      </h2>
                    </div>
                    <div className="para">
                      import an existing wallet or create a new Lorem ipsum,
                      dolor sit amet consectetur adipisicing elit. Ullam
                      laudantium accusantium officia? Maiores, voluptatem
                      accusantium. Nesciunt harum ullam quidem iusto eum aperiam
                      accusantium nisi, eaque odio quam deleniti magni ad?
                    </div>
                  </div>

                  <div className="send-btn mt-5">
                    <Link to="/dashboard">
                      <button type="submit" className="btn w-100">
                        <span>Go to Dashboard</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Congrats;
